// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5a7b9b40","74":"08765af4","215":"ef6de3a4","223":"ced9361f","275":"9c4ef2b1","409":"c45746fc","422":"adafbd90","466":"b2495901","479":"cdcb507f","775":"1db5ea37","928":"fb6d1d39","939":"2316b317"}[chunkId] + ".chunk.js";
};